<template>
  <div class="recharge">
    <div class="recharge-header">
      <template v-if="cardList.length <= 0">
        <div
          class="recharge-header-card recharge-header-empty"
          @click="addCard"
        >
          <div class="recharge-header-empty__btn">
            添加油卡 <span class="sub">>></span>
          </div>
          <div class="recharge-header-empty__text">
            支持中石油、中石化加油卡
          </div>
        </div>
      </template>
      <template v-else>
        <van-swipe
          class="recharge-header-card"
          ref="swiper"
          @change="brandChange"
        >
          <van-swipe-item
            v-for="(card, idx) in cardList"
            :key="card.id"
          >
            <div
              class="recharge-header-card-item petrol-china"
              :class="classMap[card.productType]"
            >
              <div class="recharge-header-card-item__name">
                {{ typeMap[card.productType] }}
              </div>

              <div class="recharge-header-card-item__carno">
                {{ card.cardCode }}
              </div>

              <div class="recharge-header-card-item__mobile">
                {{ card.phone }}
              </div>

              <img
                class="recharge-header-card-item__dash"
                :src="icon_del"
                @click="delCard(idx)"
              >
            </div>
          </van-swipe-item>
          <van-swipe-item key="9527">
            <div
              class="recharge-header-card recharge-header-empty"
              style="margin-top: 0"
              @click="addCard"
            >
              <div class="recharge-header-empty__btn">
                添加油卡 <span class="sub">>></span>
              </div>
              <div class="recharge-header-empty__text">
                支持中石油、中石化加油卡
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </template>
    </div>

    <denomination-select
      ref="denomination"
      :items="denomination"
      @getPrice="getPriceHandle"
      :key-fields="{
        id: 'skuValueCode',
        value: 'skuValueName',
        salePrice: rightRulePackageBindId ? 'productSkuBasePriceToYuan' : 'providerPriceToYuan',
      }"
      show-sale-price
      keep-selected
      :product-sku-code="productSkuCode"
    />

    <div class="recharge-rights">
      <right-selector
        v-model="selectedRight"
        :right-options="rightList"
        :rule-product-sku-code="curSkuItem.productSkuCode"
        :right-discount="discountPrice"
        :tips-text="tipsText"
        ref="rightSelectorRef"
        :show-right-name="!!rightRulePackageBindId"
      />
    </div>

    <van-button
      class="recharge-btn"
      type="info"
      :disabled="disabled"
      @click="goRecharge"
    >
      <strong>¥ {{ payPrice || '0.00' }}</strong>
      立即充值
    </van-button>

    <div
      class="recharge-log"
      @click="toRecordList"
    >
      充值记录
    </div>

    <!-- 说明 -->
    <template v-if="product.productDesc">
      <div class="recharge-desc">
        <div class="line" />
        <div class="text">说明</div>
        <div class="line" />
      </div>

      <div class="recharge-desctext">
        {{
          product.productDesc
        }}
      </div>
    </template>
  </div>
</template>

<script>
import DenominationSelect from '@/components/denomination-select.vue';
import RightSelector from '@/components/right-selector-new.vue';
import { evaluate } from 'mathjs/lib/cjs/index.js';
import { Dialog } from 'vant';

import {
  carLifeOrderDetail,
  carLifeOrderCreate,
  carLifePayPre,
  findValidRight,
  getAllSimpleProductInfo,
  getCardList,
  getSpecsListByProductCode,
  delCard
} from '@/common/api';
import { cloneDeep } from 'lodash';
import { cookieGet, cookieSet } from '@/common/cookie';
import Pay from '@/common/weixin';
import icon_del from '@/assets/img/car-life/icon_refuel_del@2x.png';
import { CarLifeOrderStatus } from '@/common/constant';

const typeMap = {
  1: '中国石化',
  2: '中国石油'
};

const classMap = {
  1: 'sinopec-china',
  2: 'petrol-china'
};

const valToCode = {
  1: 'SV00000302',
  2: 'SV00000301'
};
export default {
  name: 'Recharge',
  data() {
    return {
      icon_del,
      classMap,
      typeMap,
      activeCardIdx: 0,
      brand: 1,
      rechargeAmount: '',
      contactPhone: '',
      productCode: '',
      faceValue: '',
      // 面额
      denomination: [],
      cardList: [],
      rightList: [],
      originalRightList: [],
      // 已选择的权益
      selectedRight: {},
      product: {},
      orderNo: '',
      productSkuCode: '',
      rightRulePackageBindId: '',
      source: ''
    };
  },
  components: {
    DenominationSelect,
    RightSelector
  },
  computed: {
    tipsText() {
      return this.faceValue ? '请选择权益' : '请选择充值面额';
    },
    disabled() {
      // 无加油卡 || 当前为添加加油卡入口 || 未选中面额
      return this.cardList.length <= 0 || this.activeCardIdx === this.cardList.length || this.faceValue === '';
    },
    curSkuItem() {
      if (!this.product || !this.product.productStandardSkuRespVoList) {
        return {};
      }
      const skuCode = `${this.brand}|${this.faceValue}`;
      return this.product.productStandardSkuRespVoList.find(item => {
        return item.skuValueCode === skuCode;
      }) || {};
    },
    discountPrice: {
      get() {
        console.log('discountPrice get selectedRight:', this.selectedRight);
        console.log('discountPrice get rightDiscountType:', this.selectedRight.rightDiscountType);
        console.log('discountPrice get curSkuItem:', this.curSkuItem);
        console.log('discountPrice get boolean:', this.selectedRight && this.selectedRight.rightDiscountType === 2);
        if (this.selectedRight && this.selectedRight.rightDiscountType === 2) {
          console.log('discountPrice get val:', Number(this.curSkuItem.providerPriceToYuan) || 0);
          return Number(this.curSkuItem.providerPriceToYuan) || 0;
        }
        return this.selectedRight.rightDiscount || 0;
      },
      set() {}
    },
    payPrice() {
      const discount = this.discountPrice;
      console.log('payPrice:', Math.max(0, evaluate(`${this.rechargeAmount} - ${discount}`).toFixed(2)));
      console.log('payPrice1:', this.rechargeAmount);
      console.log('payPrice2:', discount);
      return Math.max(0, evaluate(`${this.rechargeAmount} - ${discount}`).toFixed(2));
    },
    curDenomination() {
      if (!this.denomination.length) {
        return {};
      }
      return this.denomination.find(type => {
        return type.skuValueCode === this.faceValue;
      }) || {};
    }
  },
  methods: {
    isEmptyObject(obj) {
      return Object.keys(obj).length <= 0;
    },
    resetDenomination() {
      this.faceValue = '';
      this.rechargeAmount = '';
      this.$refs.denomination && this.$refs.denomination.reset();
    },
    brandChange(e) {
      this.activeCardIdx = e;
      if (Number(e) === this.cardList.length) {
        return;
      }
      const card = this.cardList[e];
      this.brand = valToCode[card.productType];
      this.resetDenomination();
      this.searchSkuProduct();
      this.resetRight();
    },
    async getDetail() {
      try {
        const res = await getAllSimpleProductInfo({
          productCode: this.productCode
        });
        this.product = res || {};
        return true;
      } catch (error) {
        return false;
      }
    },

    async getSkuList() {
      try {
        const res = await getSpecsListByProductCode({
          productCode: this.productCode
        });
        const denomination = 'SP00000302';
        res.forEach(item => {
          if (item.skuAttributeCode === denomination) {
            item.psvList.forEach(item => {
              item.disabled = true;
              item.providerPriceToYuan = '0.00';
              item.productSkuBasePriceToYuan = '0.00';
            });
            this.denomination = item.psvList;
          }
        });

        // this.searchSkuProduct();
        return true;
      } catch (error) {
        return false;
      }
    },
    searchSkuProduct() {
      this.denomination.forEach(item => {
        item.disabled = true;
        item.providerPriceToYuan = '0.00';
        item.productSkuBasePriceToYuan = '0.00';
      });
      this.product.productStandardSkuRespVoList.forEach(sku => {
        const skuArr = sku.skuValueCode.split('|');
        if (skuArr[0] === this.brand) {
          this.denomination.forEach(item => {
            if (item.skuValueCode === skuArr[1]) {
              item.disabled = false;
              item.providerPriceToYuan = sku.providerPriceToYuan;
              item.productSkuBasePriceToYuan = sku.productSkuBasePriceToYuan;
            }
          });
        }
      });
    },

    getPriceHandle(price) {
      if (price.skuValueCode === this.faceValue) {
        return;
      }
      this.faceValue = price.skuValueCode;
      this.rechargeAmount = price.providerPriceToYuan;
      this.selectedRight = {};
      this.skuCodeGetRight();
      // 切换项目选择的时候，若当前选中项目有可用权益则默认选中第一个权益
      this.selectDefaultRight();
    },
    async getCardList() {
      try {
        const res = await getCardList({
          cardType: 1
        });
        this.cardList = res || [];
        return true;
      } catch (error) {
        return false;
      }
    },
    getCache() {
      if (this.$route.query.productCode) {
        this.productCode = this.$route.query.productCode;
        cookieSet('refuelProductCode', this.productCode);
      } else {
        this.productCode = cookieGet('refuelProductCode');
      }
      this.contactPhone = cookieGet('phone');
      if (this.$route.query.phone) {
        this.contactPhone = this.$route.query.phone;
      }
    },
    resetRight() {
      this.selectedRight = {};
      this.rightList = cloneDeep(this.originalRightList);
    },
    async getRightList() {
      try {
        if (!this.productCode) {
          return;
        }
        this.$toast.loading({
          message: '正在处理权益...',
          forbidClick: true,
          duration: 0
        });
        const res = await findValidRight({
          phone: this.contactPhone,
          productCode: this.productCode
        });
        this.$toast.clear();
        if (!res) {
          return;
        }
        this.originalRightList = res;
        this.originalRightList.forEach((item) => {
          item.rightId = item.rightPackageCode + '-' + item.rightCode;
          item.timesLeft = item.validCount;
          item.disabled = true; // 都是禁用的
        });
        this.rightList = cloneDeep(this.originalRightList);

        // 选中后自动筛选权益
        // if (this.faceValue) {
        //   console.log('do this.skuCodeGetRight');
        //   this.skuCodeGetRight();
        // }
        return true;
      } catch (error) {
        console.log('error', error);
        return false;
      }
    },
    // 根据sku筛选权益
    skuCodeGetRight() {
      const productSkuCode = this.curSkuItem.productSkuCode;
      console.log('skuCodeGetRight: ', productSkuCode);
      const rightList = cloneDeep(this.originalRightList);
      if (!productSkuCode) {
        this.rightList = rightList;
        return;
      }

      this.rightList = rightList
        .map((item) => {
          const rightRuleList = item.rightRuleList || [];
          console.log('skuCodeGetRight rightRuleList: ', rightRuleList);
          const isMatched = rightRuleList.some(
            ({ skuCode }) => productSkuCode === skuCode
          );
          return {
            ...item,
            disabled: !isMatched
          };
        })
        .sort((a) => (a.disabled ? 1 : -1)); // 排序，有效的放前面
    },
    toRecordList() {
      this.$router.push('/refuelRecord');
    },
    addCard() {
      this.$router.push('/newCard');
    },

    // ---------- 下单流程 start -------------
    async createOrder() {
      const card = this.cardList[this.activeCardIdx];
      const params = {
        productSkuCode: this.curSkuItem.productSkuCode,
        cardCode: card.cardCode,
        contactPhone: this.contactPhone,
        rechargeTypeName: this.curDenomination.skuValueName
      };
      if (!this.isEmptyObject(this.selectedRight)) {
        params.rightPackageCode = this.selectedRight.rightPackageCode;
        params.rightRuleCode = this.getRightRuleCode();
        params.version = this.selectedRight.version;
      }
      return await carLifeOrderCreate(params);
    },

    getRightRuleCode() {
      const right = this.selectedRight;
      for (let i = 0; i < right.rightRuleList.length; i++) {
        const rule = right.rightRuleList[i];
        if (rule.skuCode === this.curSkuItem.productSkuCode) {
          return rule.rightRuleCode;
        }
      }
    },

    async pay() {
      const envMap = ['1', '1', '4'];
      // 调起预支付接口成功后
      const prepayRs = await carLifePayPre({
        payType: envMap[this.$browserEnv], // 支付环境
        orderNo: this.orderNo
      });
      this.prePayHandle(prepayRs);
    },

    prePayHandle(payload) {
      const _payload = {
        appId: payload.appId,
        timeStamp: payload.timeStamp,
        nonceStr: payload.nonceStr,
        package: payload.packageValue,
        signType: payload.signType,
        paySign: payload.paySign,
        prepayId: payload.prepayId,
        mwebUrl: payload.mwebUrl
      };
      switch (this.$browserEnv) {
        case 0:
          Pay.mpPay(_payload, this.orderNo);
          break;
        case 1:
          Pay.wxPay(_payload, this.prePaySuccess, this.prePayFail);
          break;
        case 2:
          Pay.browserPay(_payload.mwebUrl, this.orderNo);
          break;
      }
    },

    async showConfirmDialog() {
      this.$toast.loading({
        message: '支付结果检查中...',
        forbidClick: true,
        duration: 0
      });
      this.checkPay();
    },

    async checkPay() {
      try {
        const res = await carLifeOrderDetail({
          orderNo: this.orderNo
        });
        this.$toast.clear();
        // 待支付的，去订单详情
        if (res.rechargeStatus == CarLifeOrderStatus.unpaid) {
          this.prePayFail();
        } else {
          this.prePaySuccess();
        }
      } catch (error) {
        this.$toast.clear();
      }
    },

    prePayFail() {
      this.$router.replace({
        path: '/refuelDetail',
        query: {
          orderNo: this.orderNo
        }
      });
    },

    prePaySuccess() {
      this.$router.replace({
        name: 'resultPage',
        query: {
          orderNo: this.orderNo,
          orderStatus: CarLifeOrderStatus.success,
          orderType: '01'
        }
      });
    },

    async goRecharge() {
      this.$toast.loading({
        message: '提交中',
        forbidClick: true,
        duration: 0
      });
      const res = await this.createOrder();
      this.orderNo = res.orderNo;
      if (res.needPay) {
        await this.pay();
      } else {
        this.prePaySuccess();
      }
      this.$toast.clear();
    },
    // ---------- 下单流程 end ---------------

    async delCard(idx) {
      const card = this.cardList[idx];
      try {
        await Dialog.confirm({
          title: '提示',
          message: '确认删除当前卡片？'
        });
        await delCard({
          id: card.id
        });
        //
        if (idx === this.cardList.length - 1 && idx !== 0) {
          this.activeCardIdx--;
        }
        this.$refs.swiper?.swipeTo(this.activeCardIdx);
        this.$toast('删除成功');
        this.getCardList();
      } catch (e) {
        // err Handle
      }
    },
    selectDefaultRight(right) {
      console.log('selectDefaultRight', right);
      if (!right) {
        const rightListFilter = this.rightList.filter(right => !right.disabled);
        console.log(this.brand, 'this.brand');
        console.log(this.faceValue, 'this.faceValue');
        console.log(this.rightList, 'this.rightList');
        console.log(rightListFilter, 'rightListFilter');
        console.log(this.curSkuItem, 'curSkuItem');

        if (rightListFilter.length > 0) {
          // rightListFilter.forEach(item => {
          //   if (item) {

          //   }
          //   right.rightRuleList.forEach(items => {
          //     right.rightDiscountType = Number(items.rightType);
          //     right.rightDiscount = Number(items.rightDiscount);
          //   });
          // })
          right = rightListFilter[0];
          // 处理对应的单个权益
          const productSkuCode = this.curSkuItem.productSkuCode;
          const rightRuleList = right.rightRuleList || [];
          console.log('skuCodeGetRight rightRuleList: ', rightRuleList);
          const findRightRule = rightRuleList.find(
            ({ skuCode }) => productSkuCode === skuCode
          );
          if (findRightRule) {
            right.rightDiscountType = Number(findRightRule?.rightType);
            right.rightDiscount = Number(findRightRule?.rightDiscount);
          } else {
            right = null;
          }
        }
      }
      if (right) {
        this.selectedRight = right;
        this.$nextTick(() => {
          this.$refs.rightSelectorRef?.handleSelect(right);
        });
      }
    },
    selectDefaultType() {
      // source 来源，以便判断小程序跳转
      if (this.$route.query.source === 'wxapp' && this.cardList && this.cardList.length) {
        // 处理选中加油卡类型
        const findSsku = this.product.productStandardSkuRespVoList.find(sku => sku.productSkuCode === this.$route.query.productSkuCode);
        console.log('findSsku', findSsku);

        if (findSsku) {
          const skuArr = findSsku.skuValueCode.split('|');
          const findIndex = this.cardList.findIndex(card => valToCode[card.productType] === skuArr[0]);

          console.log('findIndex', findIndex);
          if (findIndex > -1) {
            this.$refs.swiper?.swipeTo(findIndex);
          }
          // 等待swipeTo完成再继续
          setTimeout(() => {
            this.brandChange(findIndex || 0);
            this.rightList && this.rightList.forEach(item => {
              if (this.$route.query.rightRulePackageBindId == item.rightRulePackageBindId) {
                item.rightRuleList && item.rightRuleList.forEach(items => {
                  if (this.$route.query.rightRuleCode === items.rightRuleCode) {
                    const skuValueCode = items.skuValueCode;
                    // 设置默认选中
                    this.productSkuCode = this.faceValue = skuValueCode.split('|')[1];

                    this.denomination.forEach(i => {
                      if (this.faceValue === i.skuValueCode) {
                        this.rechargeAmount = Number(i.providerPriceToYuan);
                      }
                    });
                  }
                });
              }
            });
            this.skuCodeGetRight();
            this.rightList && this.rightList.forEach(item => {
              if (this.$route.query.rightRulePackageBindId == item.rightRulePackageBindId) {
                item.rightRuleList && item.rightRuleList.forEach(items => {
                  if (this.$route.query.rightRuleCode === items.rightRuleCode) {
                    // 设置默认选择权益
                    item.rightDiscountType = Number(items.rightType);
                    item.rightDiscount = Number(items.rightDiscount);
                    this.selectDefaultRight(item);
                  }
                });
              }
            });
          }, 200);
        }
      }
    },
    defaultHandle() {
      if (this.cardList.length) {
        this.brandChange(0);
      }
    }
  },
  async created() {
    this.getCache();
    if (this.$route.query.isCallBack) {
      this.orderNo = this.$route.query.orderNo;
      this.showConfirmDialog();
    }
    if (this.$route.query.productCode) {
      this.productCode = this.$route.query.productCode;
      cookieSet('refuelProductCode', this.productCode);
    }
    if (this.$route.query.rightRulePackageBindId) {
      this.rightRulePackageBindId = this.$route.query.rightRulePackageBindId;
    }
    if (this.$route.query.source) {
      this.source = this.$route.query.source;
    }
    // await this.getDetail();
    // this.getCardList();
    // this.getRightList();
    // this.getSkuList();
    const resArr = await Promise.all([this.getDetail(), this.getCardList(), this.getSkuList(), this.getRightList()]);
    console.log('resArr: ', resArr);

    const isSuccess = resArr.every(res => !!res);
    if (isSuccess) {
      if (this.rightRulePackageBindId) {
        // 处理默认选中
        this.selectDefaultType();
      } else {
        this.defaultHandle();
      }
    } else {
      this.$toast('网络异常,请返回重试！');
    }
  },
  activated() {
    // this.getCardList();
    // this.getRightList();
  }
};
</script>

<style lang="scss" scoped>
.recharge {
  min-height: 100vh;
  background-color: #F4F6F7;

  &-header {
    background-color: white;
    overflow: hidden;

    &-card {
      width: 6.9rem;
      height: 2.84rem;
      margin: 0 auto;
      margin-top: 0.56rem;

      &-item {
        position: relative;
        width: 6.9rem;
        height: 2.84rem;
        padding-left: 1.3rem;
        box-sizing: border-box;
        overflow: hidden;

        /* 中国石油 */
        &.petrol-china {
          background-image: url("./assets/petrol_china_icon.png"), url("./assets/petrol_china_bg.png");
          background-size: .72rem .72rem, cover;
          background-position: .36rem .36rem, 0 0;
          background-repeat: no-repeat, no-repeat;
        }

        /* 中国石化 */
        &.sinopec-china {
          background-image: url("./assets/sinopec_china_icon.png"), url("./assets/sinopec_china_bg.png");
          background-size: .72rem .72rem, cover;
          background-position: .36rem .36rem, 0 0;
          background-repeat: no-repeat, no-repeat;
        }

        &__name {
          font-size: .4rem;
          color: #FFFFFF;
          letter-spacing: 0.6px;
          font-weight: 500;
          margin-top: .44rem;
        }

        &__carno {
          font-size: .3rem;
          color: #FFFFFF;
          letter-spacing: 0.45px;
          font-weight: 500;
          margin-top: .32rem;
        }

        &__mobile {
          font-size: .3rem;
          color: #FFFFFF;
          letter-spacing: 0.45px;
          font-weight: 500;
          margin-top: .12rem;
        }

        &__dash {
          position: absolute;
          top: .36rem;
          right: .36rem;
          width: .36rem;
          height: .36rem;
        }
      }
    }

    &-empty {
      background: url("./assets/refuel_card_bg.png") no-repeat;
      background-size: cover;
      overflow: hidden;

      &__btn {
        display: flex;
        align-items: center;
        font-size: .4rem;
        color: #3399FF;
        letter-spacing: 0.6px;
        font-weight: 400;
        margin-top: .91rem;
        margin-left: 3.39rem;

        > .sub {
          font-size: .2rem;
          margin-left: .1rem;
        }
      }

      &__text {
        font-size: .24rem;
        color: #B3B3B3;
        letter-spacing: 0.36px;
        font-weight: 400;
        margin-top: .14rem;
        margin-left: 3.39rem;
      }
    }

  }

  &-amount {
    border-bottom: 0.02rem solid rgba(230, 230, 230, 1);

    &-input {
      padding-top: .7rem;
      font-size: .48rem;
      background-color: white;
    }
  }

  &-denomination {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    background-color: white;

    &-item {
      width: 2.1rem;
      height: 1.2rem;
      line-height: 1.2rem;
      font-size: .42rem;
      color: #383838;
      letter-spacing: 0.63px;
      font-weight: 600;
      text-align: center;
      border-radius: .16rem;
      border: 0.01rem solid #E6E6E6;
      margin: .2rem auto;
    }
  }

  &-rights {
    height: 0.98rem;
    margin-top: 0.24rem;
    background-color: white;
  }

  &-btn {
    display: block;
    width: 6.7rem;
    height: 0.96rem;
    font-size: .36rem;
    border-radius: 0.16rem;
    margin: 0 auto;
    margin-top: 0.72rem;
  }

  &-log {
    font-size: 0.32rem;
    color: #4D7399;
    text-align: center;
    font-weight: 400;
    margin: 0.48rem 0;
  }

  &-tips {
    font-size: 0.24rem;
    color: #C8C8C8;
    text-align: center;
    margin-top: 0.4rem;
  }

  &-desc {
    display: flex;
    align-items: center;
    white-space: nowrap;
    margin: 0 .4rem;
    margin-top: .96rem;

    > .line {
      width: 2.69rem;
      height: .02rem;
      background-color: #C8C8C8;
    }

    .text {
      font-size: .32rem;
      color: #383838;
      margin: 0 .34rem;
    }
  }

  &-desctext {
    font-size: .24rem;
    color: #787878;
    margin: .4rem;
    line-height: .28rem;
    white-space: pre-line;
    word-break: break-all;
  }
}
</style>
